import { useEffect, useRef, useState } from "react";

const SPEED = 150; // Characters per second

export function TypewriterWorkflowName({ name }: { name: string }) {
  const [text, setText] = useState(name);
  const frameRef = useRef<number | null>(null);
  const stateRef = useRef({
    prev: name,
    target: name,
    displayed: name,
    phase: 0,
    lastTime: 0,
    animationQueued: false,
  });

  const s = stateRef.current;
  if (name !== s.prev) {
    const wasUntitled = s.prev === "Untitled";
    s.prev = name;
    s.target = name;

    if (wasUntitled && name !== "Untitled" && !frameRef.current) {
      s.phase = 1;
      s.lastTime = 0;
      s.animationQueued = true;
    } else {
      s.displayed = name;
      setText(name);
    }
  }

  useEffect(() => {
    const s = stateRef.current;
    if (!s.animationQueued) return;
    s.animationQueued = false;

    const animate = (time: number) => {
      if (!s.lastTime) s.lastTime = time;
      const chars = Math.floor((time - s.lastTime) / (1000 / SPEED));
      if (chars > 0) {
        s.lastTime = time;
        if (s.phase === 1) {
          const len = Math.max(0, s.displayed.length - chars);
          s.displayed = s.displayed.slice(0, len);
          setText(s.displayed);
          if (!len) s.phase = 2; // typing
        } else if (s.phase === 2) {
          const len = Math.min(s.displayed.length + chars, s.target.length);
          s.displayed = s.target.slice(0, len);
          setText(s.displayed);
          if (len >= s.target.length) {
            s.phase = 0;
            frameRef.current = null;
            return;
          }
        }
      }
      if (s.phase) frameRef.current = requestAnimationFrame(animate);
      else frameRef.current = null;
    };
    frameRef.current = requestAnimationFrame(animate);
  });

  useEffect(
    () => () => {
      if (frameRef.current) cancelAnimationFrame(frameRef.current);
    },
    []
  );

  // oxlint-disable-next-line react/jsx-no-useless-fragment -- component must return JSX
  return <>{text}</>;
}
